// apps/web/src/components/webhooks/WebhooksManager.tsx
// Webhook subscription management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Webhook } from '../../types/platform.js';

export function WebhooksManager() {
  return (
    <ManagerPage
      title="Webhooks"
      listPath="/api/v1/webhooks"
      listKey="webhooks"
      createLabel="New Webhook"
      className="webhooks-manager"
      renderItem={(raw) => {
        const w = raw as Webhook;
        return (
          <div className="manager-card" key={w.id}>
            <h3>{w.url}</h3>
            <p className="status-badge">{w.status}</p>
            <p>Events: {w.eventTypes?.join(', ') ?? '*'}</p>
            <div className="actions">
              <button className="btn btn-secondary">Deliveries</button>
              <button className="btn btn-primary">Test</button>
              <button className="btn btn-warning">Disable</button>
            </div>
          </div>
        );
      }}
    />
  );
}